import * as ko from 'knockout'
import ObservableSubstitutePool from '../../../Model/Observables/ObservableSubstitutePool'
import { SubstitutesViewModel } from './SubstitutesViewModel'
import template from './substitutes.tpl.html'

if (!ko.components.isRegistered('substitutes-panel')) {
  ko.components.register('substitutes-panel', {
    viewModel: {
      createViewModel: (params: {
        availableSubstitutePools: ko.ObservableArray<ObservableSubstitutePool>
      }) => {
        const viewModel = new SubstitutesViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
